import { createMutation } from '@/utils/common.js'
const store = {
  namespaced: true,
  state: () => {
    return {
      agreementList: null, // 用户会员信息
      zhenyunAgreementList: null 
    }
  },

}

store.mutations = createMutation(store.state())

export default store
